import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";
import { resourceCache, useAsyncResource } from "use-async-resource";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Loading from "../Common/Components/Loading";
import ErrorBoundary from "../Common/Components/ErrorBoundary";
import ProjectsList from "./Components/ProjectsList";
import CategoryHeader from "../Common/Components/CategoryHeader";
import { fetchProjects } from "../../api/Fetchers";
import { ProjectDto } from "../../api/APIClient";
import PanelProjectContext from "../PanelProjectProvider";
import { ProjectContext } from "../../Context/ProjectContext";

const useStyles = makeStyles({
    root: {
        marginTop: 30,
    },
});

interface IPanelProjectContext {
    setProject: React.Dispatch<React.SetStateAction<ProjectDto>>;
}

const Projects = (): JSX.Element => {
    const classes = useStyles({ isMobile: false });
    const { t } = useTranslation("main");
    const [projectsReader, getProjects] = useAsyncResource(fetchProjects, []);
    const reloadProjects = React.useCallback(() => {
        resourceCache(fetchProjects).clear();
        getProjects();
    }, []);

    const { setProject } = React.useContext<IPanelProjectContext>(PanelProjectContext);
    const project = React.useContext<ProjectDto>(ProjectContext);
    // React.useEffect(() => {
    //     setProject(project);
    // }, []);

    return (
        <Container maxWidth="lg" className={classes.root}>
            <CategoryHeader title={t("projects.projects")} />
            <ErrorBoundary errorMessage={t("projects.projectsError")}>
                <Suspense fallback={<Loading />}>
                    <ProjectsList projectsReader={projectsReader} />
                </Suspense>
            </ErrorBoundary>
        </Container>
    );
};

export default Projects;
